import { Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { PaymentMethodDto, PaymentStartDto } from '@/api';

@Module({
  namespaced: true,
  name: 'PaymentStore',
})
export default class PaymentStore extends VuexModule {
  private viveumTransactionDetails: PaymentStartDto | null = null;
  private paymentInProgress: boolean = false;

  get currentViveumScriptUrl(): string {
    return this.viveumTransactionDetails?.widgetUrl ?? '';
  }

  get currentViveumRedirectUrl(): string {
    return this.viveumTransactionDetails?.redirectUrl ?? '';
  }

  get currentViveumBrand(): string {
    return this.viveumTransactionDetails?.brand ?? '';
  }

  get currentPaymentMethod(): PaymentMethodDto {
    return this.viveumTransactionDetails?.paymentMethod as PaymentMethodDto ?? PaymentMethodDto.CASH;
  }

  get currentTransactionAmount(): number {
    return this.viveumTransactionDetails?.transactionAmount ?? 0.0;
  }

  get isPaymentInProgress(): boolean {
    return this.paymentInProgress;
  }

  @Mutation
  public setCurrentViveumDetails(detail: PaymentStartDto) {
    this.viveumTransactionDetails = detail;
  }

  @Mutation
  public setPaymentInProgress(newValue: boolean) {
    this.paymentInProgress = newValue;
  }

  @Mutation
  public paymentCompleted() {
    this.viveumTransactionDetails = null;
    this.paymentInProgress = false;
  }
}
